import React, { useState } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import styles from './index.module.less';
import { btnTextConfig, useBlackFridayCheckInProps } from '@base/activity/blackFridayCheckIn/useBlackFridayCheckIn';
import Image from '@base/lib/ThemeImage';
import LoginModal from '@app/common/LoginModal';
import site from 'pro/config/site';
import { IconPoints } from '@pro/common/IconPoints';

type IProps = {
    checkIn: useBlackFridayCheckInProps
}

const SignIn: React.FC<IProps> = (props) => {
    const { checkIn } = props

    const [loginVisible, setLoginVisible] = useState<boolean>(false);

    const {
        onCheckInHandle,
        progressData,
        loading,
        onSeeFinalReSource,
        isLogin,
        onReloadData
    } = checkIn

    const {
        nowProcessCheckInStatus = 0,
        nowProcessNode: currentDay = 1,
        checkedDayNum = 0,
        totalPoints = 0,
        isFinal,
        pointsList = []
    } = progressData || {}

    const todayChecked = !!nowProcessCheckInStatus

    const onClickBtnHandle = async () => {
        if (!isLogin) {
            setLoginVisible(true)
        } else {
            if (isFinal) {
                onSeeFinalReSource()
            } else {
                await onCheckInHandle()
            }
        }
    }

    return (
        <>
            <div className={styles['bf-sign-in']}>
                <p className={styles['days-tips']}>
                    Checked in for <span className={styles['day']}>{checkedDayNum}</span>days in total
                </p>

                <div className={'flex'}>
                    {pointsList?.map((points, index) => {
                        const preChecked = checkedDayNum > index + 1
                        const todayChecked = checkedDayNum == index + 1
                        const checked = preChecked || todayChecked

                        return (
                            <div key={index} className={cn(
                                'flex-1',
                                styles['sign-in-item'],
                                { [styles['today-checked']]: todayChecked },
                                { [styles['pre-checked']]: preChecked },
                                { [styles['all-checked']]: isFinal },
                            )}>
                                <div className={styles['points-wrap']}>
                                    <IconPoints className={'g-icon-points'}/>
                                    <span className={styles['points']}>{points}</span>

                                    <div className={styles['arrow-down']}/>
                                </div>
                                <div className={styles['progress-wrap']}>
                                    <div className={styles['bar-wrap']}>
                                        <div className={styles['progress-bar']}/>

                                        {checked ? (
                                            <div className={styles['checked-dot']}>
                                                <Image
                                                    src={'asset/width-72/picture/2ac96445beaa45aa105d9a3d029490f8.jpg'}
                                                    width={16}
                                                    background={false}
                                                />
                                            </div>
                                        ) : (
                                            <div className={styles['un-checked-dot']}/>
                                        )}

                                    </div>
                                </div>
                                <div className={styles['day-text']}>
                                    {index + 1} {index > 0 ? 'Days' : 'Day'}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className={styles['check-in-btn-wrap']}>
                    <div className={styles['btn-wrap']}>
                        <Button
                            loading={loading}
                            disabled={!isFinal && todayChecked}
                            onClick={onClickBtnHandle}
                            className={styles['btn']}
                            type={'primary'}
                            block
                            size={'large'}
                        >
                            {
                                btnTextConfig[isFinal ? 'isFinal' : (todayChecked ? 'checked' : currentDay)]?.btnText
                            }
                        </Button>
                    </div>

                    <p className={styles.text}>
                        {totalPoints} {site.brand} Points Earned
                    </p>
                </div>

            </div>

            {/* 登录 */}
            <LoginModal
                visible={loginVisible}
                onCancel={() => setLoginVisible(false)}
                onLoginSuccess={async () => {
                    await onReloadData()
                    setLoginVisible(false)
                }}
            />
        </>

    );
};

export default SignIn